import { render, staticRenderFns } from "./PdfModalDisplayComponent.vue?vue&type=template&id=25b60801&scoped=true"
import script from "./PdfModalDisplayComponent.vue?vue&type=script&lang=js"
export * from "./PdfModalDisplayComponent.vue?vue&type=script&lang=js"
import "./PdfModalDisplayComponent.vue?vue&type=style&index=0&id=25b60801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b60801",
  null
  
)

export default component.exports